import React from 'react'
import Header from '../Header';
import Footer from '../Footer';

export default function MainLayout(props) {
    const { children } = props;
    return (
        <div className="app-layout">
            <Header
                {...props}
                showBackButton={false}
                showNotificationPanel
                showProfileBadge
                showNavbar
                showHamburgerMenu
                token={true}
            />
            <main className="app-content">
                <section className="master-page">
                    {children}
                </section>
            </main>
            <Footer />
        </div>
    )
}
